class CartItem extends HTMLElement {
  constructor() {
    super();

    this.item = this.dataset.item;
    this.removeBtn = this.querySelector('[data-remove]');

    this.removeBtn.addEventListener('click', this.handleRemove.bind(this));
  }

  async handleRemove(e) {
    e.preventDefault();
    this.classList.add('opacity-45', 'pointer-events-none');

    try {
      const data = {
        id: this.item,
        quantity: 0,
        sections: 'cart',
      };

      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();
      this.handleRemovalSuccess(responseData);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  handleRemovalSuccess(data) {
    document.body.dispatchEvent(
      new CustomEvent('cart:rebuild', {
        detail: {
          html: data.sections.cart,
        },
      }),
    );

    document.body.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart: data.items,
          shouldOpenCart: false,
        },
      }),
    );
  }
}
customElements.define('cart-item', CartItem);
